module.exports = __webpack_public_path__ + "images/help/video-calendar@2x-96da5ff8b15df1773d55bb0037c97225.png";